import styled from 'styled-components';
import Colors from 'constants/Colors';

export const Title = styled.text`
    font-weight: 600;
    color:${Colors.GRAY[6]};
`;

export const Tag = styled.li`
    cursor: 'pointer';
    width: auto;
    min-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    padding: 0 8px;
    font-size: 14px;
    list-style: none;
    border-radius: 6px;
    margin: 0 8px 8px 0;
    background: ${Colors.GREEN};
`;

export const TagTitle = styled.a`
    font-weight:bold;
    color:${Colors.GRAY[6]};
    cursor: 'pointer';
    text-decoration: none;
    text-align: center;
    width: 100%;
    height: 100%;
    display: block;
    word-break: break-all;
    padding: 5px;
`;

export const Line = styled.div`
    width: 100%;
    height: 2px;
    background-color: ${Colors.GRAY[3]};
`;

export const Tags = styled.ul`
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    margin: 8px 0 0 0;
    justify-content: space-between;
    align-items: center;
    justify-items:center;
`;

export const TagText = styled.text`
font-weight: 400;
color:${Colors.GRAY[6]};
`;

export const Container = styled.div`
    display: flex;
    flex-direction:column;
    margin-bottom: 15px;

`;